<template>
  <div class="flow">
    <img :src="$oss('device/device-detail-1.png')" class="flow-img" />
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
};
</script>
<style lang="scss" scoped>
.flow {
  background: rgba(#82c6fd, 0.11);
  padding: 15px 100px;
  margin-bottom: 20px;

  &-img {
    width: 100%;
  }
}
.texts {
  text-align: center;
  padding-top: 10px;
  &-item {
    margin-right: 12px;
  }
}
</style>
